<template>
  <div id="app">
    <keep-alive>
    <router-view v-if="$route.meta.keepAlive"></router-view>
  </keep-alive>
  <router-view v-if="!$route.meta.keepAlive"></router-view>
</div>

</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
@import './assets/css/base.less';
html{
  background: #000;
}

body {
	font-family: PingFangSC-Regular, SFNSDisplay-Regular, Segoe UI, HelveticaNeue-Light, sans-serif;
}

#app {
  color: #333;
  background: #F8F8F8;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.pages {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	width: 100%;
	height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue